import page from 'page';

import { hasLocaleVersion, getClientLocale } from './utils';

function localeRedirectionMiddleware(ctx, next) {
  const locale = getClientLocale();
  const path = ctx.pathname;

  if (hasLocaleVersion(path, locale)) {
    return page.redirect(`/${locale}${path}`);
  }

  return next();
}

export default () => localeRedirectionMiddleware;



// WEBPACK FOOTER //
// ./src/modules/locale-redirection/client.js